import axios from "axios";
import { API_URL, SELECT_MAX_RESULTS } from "./index";
class AdvertisingService {
    getAll = (params) => {
        const url = API_URL.advertising("find-by-criteria");
        const test = axios.get(url, { params }).then((response) => response);
        return test;
    };
    getAdv = (id) => {
        const url = API_URL.advertising(id);
        return axios.get(url).then((response) => response);
    };

    getAdvAsCreated = (id) => {
        const url = API_URL.advertising(`dto/${id}`);
        return axios.get(url).then((response) => response);
    };

    getByIds = (ids) => {
        const url = API_URL.advertising("by-ids");
        return axios.get(url, {
            params: { ids },
        });
    };

    createAdv = (body) => {
        const url = API_URL.advertising();
        return axios.post(url, body).then((response) => response);
    };
    deleteAdv = (id) => {
        const url = API_URL.advertising(id);
        return axios.delete(url).then((response) => response);
    };
    deleteMultipleAdv = (ids) => {
        const url = API_URL.advertising("by-ids");
        return axios.delete(url, {params: { ids }}).then((response) => response);
    };
    editAdv = (body) => {
        const url = API_URL.advertising();
        return axios.put(url, body).then((response) => response);
    };

    getNomenclator = (url) => axios.get(url);
    getFilmByTitle = ({ titlePattern, companyIds }) => {
        const url = API_URL.filmRelease("find-by-title");
        return axios.get(url, {
            params: {
                titlePattern,
                companyIds,
                maxResults: SELECT_MAX_RESULTS,
            },
        });
    };
    getFilmReleaseById = (id) => {
        const url = API_URL.filmRelease(id);
        return axios.get(url);
    };

    getAdvsByIds = (ids) => {
        const url = API_URL.advertising("by-ids?ids=" + ids);
        return axios.get(url).then((response) => response);
    };

    getCompanyByTitle = (namePattern) => {
        const url = API_URL.companyRelease("find-by-title");
        return axios.get(url, {
            params: {
                namePattern,
                maxResults: SELECT_MAX_RESULTS,
            },
        });
    };
    getCompanyByID = (id) => {
        const url = API_URL.companyRelease(id);
        return axios.get(url, {
            params: {
                loadAllContacts: false,
            },
        });
    };

    getTags = () => {
        const url = API_URL.tags();
        return axios.get(url).then((response) => ({
            data: response.data.sort((a, b) => a.value.localeCompare(b.value)),
        }));
    };

    getAttributeTypes = () => {
        const url = API_URL.attributeType();
        return axios.get(url);
    };
}

export default new AdvertisingService();
